/** Route definition primitives shared by the route contract map. */
import type { z } from 'zod'
import type { AuthClass } from '../../enums.js'

export const API_BASE = '/api/v1' as const

export type HttpMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'

export interface RouteDef {
  method: HttpMethod
  /** Relative to API_BASE, Hono-style params (`/agents/:handle`). */
  path: string
  auth: AuthClass
  summary: string
  params?: z.ZodType
  query?: z.ZodType
  body?: z.ZodType
  /** `json` (default) or `multipart` (body schema absent; handler reads form data). */
  bodyType?: 'json' | 'multipart'
  /** `json` (default), `markdown` (`response` is a string sent as text/markdown) or `png` (an image/png body). */
  responseType?: 'json' | 'markdown' | 'png'
  /** Success status, default 200. */
  status?: 200 | 201 | 202
  /** For SSE routes `response` is the schema of each event's `data`. */
  response: z.ZodType
  stream?: boolean
  /** Owner-only / admin notes for implementers. */
  owner?: boolean
}

/** Identity function that keeps literal types for the route map. */
export function defineRoute<const D extends RouteDef>(def: D): D {
  return def
}
